import React, { useState, useEffect, useMemo, useRef } from 'react';
import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from '@mui/material/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

    Divider,
    Chip,
    Card,
    CardContent,
    LinearProgress,

} from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@material-ui/core/IconButton';
import {
    MaterialReactTable,

} from 'material-react-table';
import VisibilityIcon from '@mui/icons-material/Visibility';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TaskIcon from '@mui/icons-material/Task';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


import { calculateBusinessHoursBetween } from './SLAUtils';
import CancelIcon from '@mui/icons-material/Cancel';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import { Drawer, SwipeableDrawer, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import InsightsIcon from '@mui/icons-material/Insights';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import GroupsIcon from '@mui/icons-material/Groups';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ScheduleIcon from '@mui/icons-material/Schedule';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import VisaoGeral from './visaoGeral';
import Tarefas from './tarefas';
import Cronograma from "./cronograma";
import LogInterativo from './LogInterativo';


import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import {
    Box,
    Tooltip
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

import { Button } from "@material-ui/core";
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ReactApexChart from "react-apexcharts";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Timeline } from 'rsuite';
import CreditCardIcon from '@rsuite/icons/legacy/CreditCard';
import PlaneIcon from '@rsuite/icons/legacy/Plane';
import TruckIcon from '@rsuite/icons/legacy/Truck';
import UserIcon from '@rsuite/icons/legacy/User';
import CheckIcon from '@rsuite/icons/legacy/Check';
import './Timeline.css';
import { useTheme } from "@mui/material/styles";
import {

    ListItemButton,
    Menu,
    MenuItem, useMediaQuery
} from "@mui/material";
import { useLocation } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';


const drawerWidth = 240;

// 🧠 Função de segurança para parsear JSON apenas quando necessário
const safeParse = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === 'object') return value; // já é um objeto
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

// Componentes Auxiliares para o Detail Panel
const DetailBox = ({ label, value, darkMode, multiline }) => (
    <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ color: darkMode ? '#aaa' : 'text.secondary' }}>{label}:</Typography>
        <Typography variant="body1" sx={{ mt: 0.5, whiteSpace: multiline ? 'pre-line' : 'normal' }}>{value || '—'}</Typography>
    </Box>
);

const ProcedureCard = ({ proc, darkMode, themeHelper, formatDate }) => (
    <Card variant="outlined" sx={{
        borderRadius: 2, backgroundColor: themeHelper.paper, borderColor: themeHelper.border,
        boxShadow: darkMode ? '0 1px 3px rgba(0,0,0,0.4)' : '0 1px 3px rgba(0,0,0,0.08)', p: 2, color: themeHelper.text,
    }}>
        <Typography variant="subtitle2" fontWeight="bold" color="primary" gutterBottom>
            {proc.procedimento?.nome || 'Procedimento sem nome'}
        </Typography>
        <Typography variant="caption" display="block" sx={{ mb: 0.5 }}><b>Criação:</b> {formatDate(proc.data_hora_criacao)}</Typography>
        <Typography variant="caption" display="block" sx={{ mb: 0.5 }}><b>Criador:</b> {proc.usuario_criador?.nome_amigavel || '—'}</Typography>
        <Typography variant="caption" display="block" sx={{ mb: 0.5 }}><b>Execução:</b> {formatDate(proc.data_hora_execucao)}</Typography>
        <Typography variant="caption" display="block"><b>Executor:</b> {proc.usuario_executor?.nome_amigavel || '—'}</Typography>
    </Card>
);

const PriorityActionMenu = ({ currentPriority, onUpdate }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const priorities = [
        { label: '🟢 Comum', value: 0 },
        { label: '🟡 Urgente', value: 1 },
        { label: '🔴 Priorizar', value: 2 }
    ];

    return (
        <>
            <Button
                variant="outlined"
                color={currentPriority === 2 ? 'secondary' : 'default'}
                startIcon={<RadioButtonUncheckedIcon />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{ borderRadius: 2, textTransform: 'none' }}
            >
                Prioridade: {priorities.find(p => p.value === currentPriority)?.label.split(' ')[1] || 'Definir'}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                {priorities.map((p) => (
                    <MenuItem key={p.value} onClick={() => { onUpdate(p.value); setAnchorEl(null); }}>
                        {p.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

// Componentes Auxiliares para o Workflow / Timeline
const TimelineNode = ({ icon, borderColor, bgColor, pulse, tooltipTitle, extra }) => (
    <Tooltip title={tooltipTitle} arrow>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{
                width: 22, height: 22, border: `2px solid ${borderColor}`, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backgroundColor: bgColor || 'transparent',
                animation: pulse ? 'pulseZoom 2s infinite ease-in-out' : 'none',
                '@keyframes pulseZoom': {
                    '0%': { backgroundColor: 'transparent', transform: 'scale(1)' },
                    '50%': { backgroundColor: '#ffcdd2', transform: 'scale(1.3)' },
                    '100%': { backgroundColor: 'transparent', transform: 'scale(1)' },
                },
                cursor: 'help',
            }}>
                {React.cloneElement(icon, { sx: { ...icon.props.sx, fontSize: 12 } })}
            </Box>
            {extra}
        </Box>
    </Tooltip>
);

const Connector = ({ active, pulse }) => (
    <Box sx={{
        width: 30, height: 2, alignSelf: 'center',
        background: active ? 'green' : 'linear-gradient(90deg, transparent, #ffcdd2, transparent)',
        animation: pulse ? 'pulseLine 2s infinite ease-in-out' : 'none',
        '@keyframes pulseLine': {
            '0%': { background: 'linear-gradient(90deg, transparent, #ffcdd2, transparent)' },
            '50%': { background: 'linear-gradient(90deg, transparent, #e57373, transparent)' },
            '100%': { background: 'linear-gradient(90deg, transparent, #ffcdd2, transparent)' },
        },
    }} />
);

const OSDetailPanel = ({ row, darkMode, themeHelper, handleUpdatePriority, handleOpenCronograma }) => {
    const ordem = row.original;

    const instalacao = safeParse(ordem.instalacao);
    const analista = safeParse(ordem.analista);
    const solicitante = safeParse(ordem.usuario_solicitante);
    const procedimentos = Array.isArray(ordem.procedimentos) ? ordem.procedimentos : safeParse(ordem.procedimentos, []);

    const formatDate = (dateString) => {
        if (!dateString) return '—';
        let date;
        // Jackson serializa LocalDateTime como array: [2025, 4, 18, 18, 0, 0]
        if (Array.isArray(dateString)) {
            const [year, month, day, hour = 0, minute = 0, second = 0] = dateString;
            date = new Date(year, month - 1, day, hour, minute, second);
        } else if (typeof dateString === 'string') {
            // suporte a formato MySQL "YYYY-MM-DD HH:mm:ss" e ISO
            date = new Date(dateString.replace(' ', 'T'));
        } else {
            date = new Date(dateString);
        }
        if (!date || isNaN(date.getTime())) return '—';
        return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    };

    const getStatusLabel = (status) => {
        switch (parseInt(status)) {
            case 0: return 'Aberta';
            case 1: return 'Ordem designada (Tratamento Remoto)';
            case 2: return 'Análise Pré-Tratamento em Campo';
            case 3: return 'Tratamento em Campo';
            case 9: return 'Concluída';
            default: return 'Desconhecido';
        }
    };

    const getStatusColor = (status) => {
        switch (parseInt(status)) {
            case 0: return 'info';
            case 1: return 'warning';
            case 2: return 'secondary';
            case 3: return 'primary';
            case 9: return 'success';
            default: return 'default';
        }
    };

    const handlePrintPDF = async () => {
        try {
            const token = Cookies.get('token');
            const response = await api.get(`v1/protected/ordemservico/imprimir-resumo/${ordem.id_ordem_servico}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
            
            const blob = response.data;
            const url = URL.createObjectURL(blob);
            const novaGuia = window.open(url, '_blank');
            // libera memória após a guia carregar
            if (novaGuia) {
                novaGuia.onload = () => URL.revokeObjectURL(url);
            } else {
                setTimeout(() => URL.revokeObjectURL(url), 10000);
            }
        } catch (err) {
            console.error('Erro ao imprimir PDF:', err);
            alert('Não foi possível gerar o PDF. Tente novamente.');
        }
    };

    return (
        <Card variant="outlined" sx={{
            m: 2, p: 3, backgroundColor: themeHelper.paper, color: themeHelper.text, borderRadius: 3,
            boxShadow: darkMode ? '0 4px 12px rgba(0,0,0,0.5)' : '0 4px 12px rgba(0,0,0,0.1)', borderColor: themeHelper.border,
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Typography variant="h5" color="primary" sx={{ fontWeight: 'bold' }}>Painel da Ordem #{ordem.id_ordem_servico}</Typography>
                <Stack direction="row" spacing={1}>
                    <Tooltip title="Imprimir Resumo em PDF">
                        <Button variant="contained" color="primary" startIcon={<VisibilityIcon />} onClick={handlePrintPDF} sx={{ borderRadius: 2, textTransform: 'none' }}>Imprimir</Button>
                    </Tooltip>
                    <Tooltip title="Copiar Link para Compartilhamento">
                        <Button variant="outlined" startIcon={<InsightsIcon />} onClick={() => {
                            const url = `${window.location.origin}${window.location.pathname}?busca=${ordem.id_ordem_servico}`;
                            navigator.clipboard.writeText(url); window.alert('Link copiado!');
                        }} sx={{ borderRadius: 2, textTransform: 'none' }}>Copiar Link</Button>
                    </Tooltip>
                    <PriorityActionMenu currentPriority={ordem.nivel_prioridade} onUpdate={(p) => handleUpdatePriority(ordem.id_ordem_servico, p)} />
                </Stack>
            </Box>

            <Grid container spacing={4}>
                <Grid item xs={12} lg={7}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <DetailBox label="Data Criação" value={formatDate(ordem.data_hora_criacao)} darkMode={darkMode} />
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ color: darkMode ? '#aaa' : 'text.secondary' }}>Status</Typography>
                                <Chip label={getStatusLabel(ordem.status_ordem)} color={getStatusColor(ordem.status_ordem)} size="small" sx={{ mt: 0.5, fontWeight: 'bold' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DetailBox label="Instalação" value={`${instalacao.nome_fantasia || '—'}\nCNPJ: ${instalacao.cnpj || '—'}`} darkMode={darkMode} multiline />
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Typography variant="subtitle2" sx={{ color: darkMode ? '#aaa' : 'text.secondary' }}>Envolvidos:</Typography>
                                <Typography variant="caption" sx={{ color: themeHelper.textPrimary }}>• <b>Solicitante:</b> {solicitante?.nome_amigavel || '—'}</Typography>
                                <Typography variant="caption" sx={{ color: themeHelper.textPrimary }}>• <b>Criador:</b> {ordem.usuario_criador?.nome_amigavel || '—'}</Typography>
                                <Typography variant="caption" sx={{ color: themeHelper.textPrimary }}>• <b>Analista:</b> {analista?.nome_amigavel || '—'}</Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 3 }} />
                    
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FactCheckIcon color="primary" /> Solicitação
                    </Typography>
                    <Box sx={{ bgcolor: darkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', p: 2, borderRadius: 2, mb: 3 }}>
                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>{ordem.nome_solicitacao}</Typography>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-line', color: themeHelper.textSecondary }}>{ordem.descricao_solicitacao || 'Sem descrição.'}</Typography>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <HistoryToggleOffIcon color="primary" /> Fluxo e Progresso
                    </Typography>
                    
                    <Box sx={{ mb: 4, px: 2 }}>
                        {/* Timeline Horizontal */}
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0, justifyContent: 'center', mb: 3 }}>
                            {(() => {
                                const status = parseInt(ordem.status_ordem);
                                const dataHoraCriacaoFormatada = moment(ordem.data_hora_criacao, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM');
                                const dataHoraFinalizouTratamentoRemoto = moment(ordem.data_hora_finalizacao_tratamento_remoto, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM');
                                
                                const stages = [
                                    { id: 0, title: `Criado: ${dataHoraCriacaoFormatada}`, icon: EditIcon },
                                    { id: 1, title: status === 1 ? 'Tratamento Remoto: Em curso' : 'Tratamento Remoto', icon: ComputerOutlinedIcon },
                                    { id: 2, title: status === 2 ? 'Análise Prévia: Em curso' : 'Análise Prévia', icon: SearchOutlinedIcon },
                                    { id: 3, title: status === 3 ? 'Tratamento em Campo: Em curso' : 'Tratamento em Campo', icon: TaskIcon },
                                    { id: 9, title: status === 9 ? `Conclusão: ${dataHoraFinalizouTratamentoRemoto}` : 'Conclusão', icon: TaskAltIcon }
                                ];

                                return stages.map((stage, idx) => {
                                    const state = status === 9 ? 'passed' : stage.id === 9 ? 'future' : status === stage.id ? 'current' : status > stage.id ? 'passed' : 'future';
                                    const isPassed = state === 'passed';
                                    const isCurrent = state === 'current';
                                    const color = isPassed ? '#2e7d32' : isCurrent ? '#e57373' : themeHelper.textSecondary;

                                    return (
                                        <React.Fragment key={stage.id}>
                                            <TimelineNode
                                                tooltipTitle={stage.title}
                                                borderColor={color}
                                                bgColor={isCurrent ? '#fce4ec' : 'transparent'}
                                                pulse={isCurrent}
                                                icon={<stage.icon sx={{ color }} />}
                                            />
                                            {idx < stages.length - 1 && (
                                                <Connector active={status > stage.id || status === 9} pulse={isCurrent} />
                                            )}
                                        </React.Fragment>
                                    );
                                });
                            })()}
                        </Box>

                        {/* Cronograma (Barra) */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            {(() => {
                                const total = ordem.total_tarefas || 0;
                                const concluidas = ordem.tarefas_concluidas || 0;
                                const percent = total > 0 ? Math.round((concluidas / total) * 100) : 0;
                                
                                return (
                                    <Tooltip
                                        title={
                                            <Box sx={{ p: 1 }}>
                                                <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block', mb: 1, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                                                    Procedimentos do Agendamento:
                                                </Typography>
                                                <Box sx={{ whiteSpace: 'pre-line', fontSize: '10px' }}>
                                                    {ordem.procedimentos_detalhes || "Nenhum procedimento encontrado"}
                                                </Box>
                                            </Box>
                                        }
                                    >
                                        <Box 
                                            sx={{ display: 'flex', alignItems: 'center', gap: '15px', cursor: 'pointer', flexGrow: 1, bgcolor: darkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)', p: 2, borderRadius: 2 }} 
                                            onClick={(e) => handleOpenCronograma(ordem, e)}
                                        >
                                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                {percent === 100 ? (
                                                    <TaskAltIcon sx={{ color: '#2e7d32', fontSize: 32 }} />
                                                ) : percent > 0 ? (
                                                    <HistoryToggleOffIcon sx={{ color: '#0288d1', fontSize: 32 }} />
                                                ) : (
                                                    <HistoryToggleOffIcon sx={{ color: '#d32f2f', fontSize: 32 }} />
                                                )}
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: themeHelper.text }}>
                                                        Progresso Geral: {percent}%
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: themeHelper.textSecondary }}>
                                                        {concluidas}/{total} tarefas concluídas
                                                    </Typography>
                                                </Box>
                                                <LinearProgress 
                                                    variant="determinate" 
                                                    value={percent} 
                                                    sx={{ 
                                                        height: 8, 
                                                        borderRadius: 4,
                                                        bgcolor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                                        '& .MuiLinearProgress-bar': {
                                                            bgcolor: percent === 100 ? '#2e7d32' : '#0288d1'
                                                        }
                                                    }} 
                                                />
                                            </Box>
                                        </Box>
                                    </Tooltip>
                                );
                            })()}
                        </Box>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FactCheckIcon color="primary" /> Procedimentos Técnicos
                    </Typography>
                    {procedimentos.length > 0 ? (
                        <Grid container spacing={2}>
                            {procedimentos.map((proc, i) => <Grid item xs={12} sm={6} key={i}><ProcedureCard proc={proc} darkMode={darkMode} themeHelper={themeHelper} formatDate={formatDate} /></Grid>)}
                        </Grid>
                    ) : <Typography variant="body2" color="textSecondary">Nenhum procedimento registrado.</Typography>}
                </Grid>

                <Grid item xs={12} lg={5}>
                    <LogInterativo ordemId={ordem.id_ordem_servico} darkMode={darkMode} themeHelper={themeHelper} />
                </Grid>
            </Grid>
        </Card>
    );
};





export default function OrdensDeServicos() {

    const [isCabecalho, setIsCabecalho] = useState(true);
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode');
        return saved === 'true';
    });

    const themeHelper = {
        bg: darkMode ? "#252525" : "#e9eff3",
        paper: darkMode ? "#2e2e2e" : "#f5f8fa",
        text: darkMode ? "#ffffff" : "#1a1a1a",
        textSecondary: darkMode ? "#aaaaaa" : "#5a6a7a",
        border: darkMode ? "#444444" : "#d1d9e0",
        navbarBg: darkMode ? "#252525" : "#ffffff",
        navbarVariant: darkMode ? "dark" : "light",
    };

    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm")); // mobile até sm
    const [tableHeight, setTableHeight] = useState(400); // valor inicial qualquer

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('temaChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('temaChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
        };
    }, []);

    const themeV5 = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            }
        },
    }), [darkMode]);

    const themeV4 = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
                secondary: darkMode ? '#aaaaaa' : '#666666',
            }
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    },
                } : {},
            },
            MuiFormLabel: {
                root: darkMode ? {
                    color: 'white',
                    '&$focused': {
                        color: 'white'
                    }
                } : {}
            },
            MuiInputBase: {
                input: darkMode ? {
                    color: 'white',
                } : {}
            },
            MuiAutocomplete: {
                root: darkMode ? {
                    '& .MuiInputLabel-root': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                } : {},
                popupIndicator: darkMode ? {
                    color: 'white'
                } : {},
                clearIndicator: darkMode ? {
                    color: 'white'
                } : {},
                paper: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white'
                } : {}
            },
            MuiDialog: {
                paper: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white'
                } : {}
            },
            MuiTypography: {
                colorTextSecondary: darkMode ? {
                    color: '#aaaaaa'
                } : {}
            }
        },
    }), [darkMode]);



    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 300); // altura da tela menos 200px
        };

        updateHeight(); // calcula ao montar o componente
        window.addEventListener('resize', updateHeight); // recalcula ao redimensionar

        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const menuParam = parseInt(query.get("menu"));


    const regra = Cookies.get("regra") || "";


    const [loading, setLoading] = useState(true);
    const [eventosAtivos, setEventosAtivos] = useState([]);

    useEffect(() => {
        const fetchEventos = async () => {
            try {
                const response = await api.get('/v1/protected/eventoglobal/listartodos', {
                    headers: { 'Authorization': 'Bearer ' + Cookies.get('token') }
                });
                setEventosAtivos(response.data.filter(e => e.status === 1));
            } catch (err) {
                console.error("Erro ao carregar feriados para a tabela:", err);
            }
        };
        fetchEventos();
    }, []);

    const [value, setValue] = React.useState(1);
    const [viewMode, setViewMode] = useState('table');


    useEffect(() => {
        if (!isNaN(menuParam) && menuParam > 0) {
            setValue(menuParam);
        }
    }, [menuParam]);

    const [open2, setOpen2] = useState(false);

    const [open, setOpen] = useState(false);
    const [commentsMap, setCommentsMap] = useState({});
    const [isPostingComment, setIsPostingComment] = useState(false);

    const fetchComments = async (idOS) => {
        try {
            const token = Cookies.get('token');
            const response = await api.get(`/v1/protected/ordemservico/comentario/listar/${idOS}`, {
                headers: { 'Authorization': 'Bearer ' + token }
            });
            setCommentsMap(prev => ({ ...prev, [idOS]: response.data }));
        } catch (err) {
            console.error("Erro ao buscar comentários:", err);
        }
    };

    const handlePostComment = async (idOS, mensagem, foto) => {
        if (!mensagem && !foto) return;
        setIsPostingComment(true);
        try {
            const token = Cookies.get('token');
            const idUsuario = Cookies.get('id_usuario');
            const formData = new FormData();
            formData.append('id_ordem_servico', idOS);
            formData.append('id_usuario', idUsuario);
            formData.append('mensagem', mensagem);
            if (foto) formData.append('foto', foto);

            await api.post('/v1/protected/ordemservico/comentario/gravar', formData, {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
            fetchComments(idOS);
        } catch (err) {
            console.error("Erro ao postar comentário:", err);
        } finally {
            setIsPostingComment(false);
        }
    };

    const handleUpdatePriority = async (idOS, priority) => {
        try {
            const token = Cookies.get('token');
            await api.put(`/v1/protected/ordemservico/atualizarprioridade/${idOS}/${priority}`, {}, {
                headers: { 'Authorization': 'Bearer ' + token }
            });
            // Recarregar dados da tabela (objetos) seria o ideal, ou atualizar localmente
            // Para simplicidade, vamos apenas admitir que funcionou ou disparar um refresh global se houver
            window.location.reload(); // Refresh bruto para garantir consistência visual em todas as views
        } catch (err) {
            console.error("Erro ao atualizar prioridade:", err);
        }
    };

    const touchStartRef = useRef(null);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [openCronograma, setOpenCronograma] = useState(false);
    const [ordemServicoCronograma, setOrdemServicoCronograma] = useState(null);
    const [loadingCronogramaId, setLoadingCronogramaId] = useState(null);

    const handleOpenCronograma = async (ordemServicoSimples, e) => {
        e.stopPropagation();
        setLoadingCronogramaId(ordemServicoSimples.id_ordem_servico);
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };
            const res = await api.get("/v1/protected/ordemservico/listarporid/" + ordemServicoSimples.id_ordem_servico, { headers });
            setOrdemServicoCronograma(res.data);
            setOpenCronograma(true);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingCronogramaId(null);
        }
    };

    const handleCloseCronograma = () => {
        setOpenCronograma(false);
        setOrdemServicoCronograma(null);
    };

    const listarInformacoesCronograma = async () => {
        if (!ordemServicoCronograma) return;
        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };
            const res = await api.get("/v1/protected/ordemservico/listarporid/" + ordemServicoCronograma.id_ordem_servico, { headers });
            setOrdemServicoCronograma(res.data);
            listarOrdensServicos(); // para atualizar a tabela principal
        } catch (err) {
            console.error("Erro ao recarregar dados do cronograma:", err);
        }
    };



    const [filtroChecked, setFiltroChecked] = useState(() => {
        if (regra.includes("ADMIN_OC_MINHAS_OS")) {
            return true; // força sempre true
        }

        const cookie = Cookies.get("filtro_ordem_servico");
        return cookie ? cookie === "true" : true; // se não existir, true
    });


    function handleFiltroChecked(v) {
        setFiltroChecked(v);
        Cookies.set("filtro_ordem_servico", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }





    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 30,
    });


    const [totalRegistros, setTotalRegistros] = useState(0);
    const [filtro, setFiltro] = useState("");

    const [objetos, setObjetos] = useState(null);



    const [options, setOptions] = useState(() => {
        const currentMonth = new Date().toLocaleString('pt-BR', { month: 'long' });
        const monthName = currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1);

        return {
            chart: {
                type: "bar",
                height: '100%',
                width: '100%',
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 4,
                    dataLabels: {
                        position: "center",
                    },
                    // Aplica cor por ponto (por barra individual)
                    distributed: true,
                },
            },
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: "18px",
                },
            },
            xaxis: {
                categories: ["Criadas", "Abertas", "Concluídas"],
                title: {
                    text: "Quantidade de O.S",
                },
            },
            colors: ["#008FFB", "#FF6347", "#32CD32"], // Azul, Vermelho claro, Verde
            title: {
                text: `Ordens de Serviço (${monthName})`,
                align: "center",
                style: {
                    fontSize: "18px",
                    fontWeight: "bold",
                },
            },
        };
    });

    const [series, setSeries] = useState([
        {
            data: [0, 0, 0],
        },
    ]);



    const [dadosGrafico, setDadosGrafico] = useState({
        series: [],
        options: {
            chart: {
                height: "100%",
                type: "line",
                width: "100%",
            },
            colors: ["#0288d1", "#FF5733", "#33FF57", "#5733FF", "#FFC300"], // Definição de cores diferentes para cada equipamento
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 3,
                curve: "smooth",
            },
            xaxis: {
                categories: [], // Será preenchido dinamicamente com os dias do mês
                title: {
                    text: "Mês/Ano",
                },
            },
            yaxis: {
                title: {
                    text: "O.Ss por todo o período",
                },
            },
            markers: {
                size: 5,
                strokeColors: "#fff",
                strokeWidth: 2,
            },
            fill: {
                opacity: 1,
            },
        },
    });



    async function listarOrdensServicos() {
        const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10);

        try {
            const token = Cookies.get('token');
            const id_usuario = Cookies.get('id_usuario');
            const headers = { 'Authorization': 'Bearer ' + token };
            const regra = Cookies.get('regra');


            let response2;
            if (regra.includes("ADMIN")) {
                response2 = await api.get(
                    `v1/protected/ordemservico/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}`,
                    { headers }
                );
            } else if (regra.includes("TEC_OS")) {
                setIsCabecalho(false);
                setFiltroChecked(false);
                response2 = await api.get(
                    `v1/protected/ordemservico/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}&usuario_id=${id_usuario}`,
                    { headers }
                );
            }

            const dadosOriginais = response2.data.dados;

            const dadosFiltrados = dadosOriginais.filter((ordem_servico) => {
                if (filtroChecked || regra.includes("ADMIN_OC_MINHAS_OS")) {
                    const solicitanteId = parseInt(ordem_servico.usuario_solicitante?.id_usuario || 0, 10);
                    const criadorId = parseInt(ordem_servico.usuario_criador?.id_usuario || 0, 10);
                    const analistaId = parseInt(ordem_servico.analista?.id_usuario || 0, 10);

                    // Retorna true se o usuário logado for solicitante, criador ou analista
                    return (
                        solicitanteId === id_usuario_logado ||
                        criadorId === id_usuario_logado ||
                        analistaId === id_usuario_logado
                    );
                } else {
                    // Se o filtroChecked estiver desativado, mostra todas as OS
                    return true;
                }
            });

            setObjetos(dadosFiltrados);
            setTotalRegistros(dadosFiltrados.length);



            setLoading(false);





        } catch (err) {
            console.error("Erro ao listar objetos:", err);
            setLoading(false);
        }
    }









    useEffect(() => {

        listarOrdensServicos();


    }, [filtroChecked, pagination]);


    const [infoDashboard, setInfoDashboard] = useState(null);
    const [loadingDashboard, setLoadingDashboard] = useState(true);


    async function listarInfoDashboard() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/ordemservico/listarinfodashboard", {
                headers: headers
            }).then(function (response) {

                setInfoDashboard(response.data);





                const criadas = response.data.dashboardInfo.totalMesCriadas;
                const abertas = response.data.dashboardInfo.totalMesAbertas;
                const concluidas = response.data.dashboardInfo.totalMesConcluidas;




                if (response?.data?.dashboardInfoTodoPeriodo) {
                    const dados = response.data.dashboardInfoTodoPeriodo;

                    const categorias = dados.map(item => `${String(item.mes).padStart(2, '0')}/${item.ano}`);
                    const criadas = dados.map(item => item.totalMesCriadas);
                    const abertas = dados.map(item => item.totalMesAbertas);
                    const concluidas = dados.map(item => item.totalMesConcluidas);

                    setDadosGrafico(prev => ({
                        ...prev,
                        series: [
                            { name: 'Criadas', data: criadas },
                            { name: 'Abertas', data: abertas },
                            { name: 'Concluídas', data: concluidas }
                        ],
                        options: {
                            ...prev.options,
                            xaxis: {
                                ...prev.options.xaxis,
                                categories: categorias
                            }
                        }
                    }));
                }

                setSeries([
                    {
                        data: [criadas, abertas, concluidas],
                    },
                ]);

                setLoadingDashboard(false);

            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar dados de Ordens de Serviços: " + _err)

        }

    }



    async function reavaliar() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/ordemservico/reavaliar", {
                headers: headers
            }).then(function (response) {

            });
        } catch (_err) {
            console.log("Erro ao reavaliar: " + _err)
        }

    }



    useEffect(() => {


        listarInfoDashboard();


    }, []);









    function novo() {
        window.location.href = "/gestao/administracao/ordensdeservicos/cadastrarordemservico"

    }




    const handleClickEdicaoOC = (row) => {


        window.location.href = "/gestao/administracao/ordensdecompras/editar/" + row.id_ordem_compra;


    };


    const handleClickEdicao = (cellValues) => {
        const url =
            "/gestao/administracao/ordensdeservicos/editar/" +
            cellValues.id_ordem_servico;

        window.open(url, isMobile ? "_self" : "_blank");
    };


    function returnDescricaoInstalacao(instalacao) {
        var texto = "" + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia) +
            " | SIGMA: " + instalacao.identificador_integrador;

        return texto;
    }









    const columns = useMemo(
        () => [
            {
                id: 'id_ordem',
                header: 'ID',
                size: 60,
                accessorFn: row => row.id_ordem_servico,
                Cell: ({ cell, row }) => (
                    <Typography
                        variant="body2"
                        onClick={() => handleClickEdicao(row.original)}
                        style={{
                            cursor: 'pointer',
                            color: '#1976d2',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                            fontSize: 13
                        }}
                    >
                        #{cell.getValue()}
                    </Typography>
                ),
            },
            {
                header: 'Criação / SLA',
                id: 'criacao_sla',
                size: 180,
                enableSorting: true,
                accessorFn: row => row.data_hora_criacao,
                Cell: ({ row }) => {
                    const ordem = row.original;
                    const status = parseInt(ordem.status_ordem);
                    
                    // --- Lógica de Criação ---
                    const dataObj = moment(ordem.data_hora_criacao, 'YYYY-MM-DD HH:mm:ss');
                    let fDt = "—";
                    let tempoAtras = "";
                    if (dataObj.isValid()) {
                        fDt = dataObj.format("HH:mm DD/MM/YYYY");
                        const inicio = dataObj.toDate();
                        const agora = new Date();
                        const diffMs = agora - inicio;
                        const horas = Math.floor(diffMs / (1000 * 60 * 60));
                        const dias = Math.floor(horas / 24);
                        if (dias >= 1) {
                            tempoAtras = `${dias} dia${dias > 1 ? "s" : ""} atrás`;
                        } else if (horas >= 1) {
                            tempoAtras = `${horas} hora${horas > 1 ? "s" : ""} atrás`;
                        } else {
                            tempoAtras = "menos de 1h atrás";
                        }
                    }

                    // --- Lógica de SLA/Prioridade ---
                    let prioridadeLabel = "Comum (72h)";
                    let prioridadeColor = "gray";
                    let prioridadeIcon = "🕒";
                    const nivel = ordem.nivel_prioridade ? parseInt(ordem.nivel_prioridade) : 0;
                    if (nivel === 1) { prioridadeLabel = "Urgente (48h)"; prioridadeColor = "#ed6c02"; prioridadeIcon = "🔥"; }
                    if (nivel === 2) { prioridadeLabel = "Priorizar (24h)"; prioridadeColor = "#d32f2f"; prioridadeIcon = "🚨"; }

                    let slaLabel = "S/ SLA";
                    let slaColor = "gray";
                    if (ordem.data_limite_sla) {
                        const limite = moment(ordem.data_limite_sla, 'YYYY-MM-DD HH:mm:ss');
                        let referenciaAtual = moment();
                        if (status === 9) {
                            if (ordem.data_hora_finalizacao_tratamento_em_campo) {
                                referenciaAtual = moment(ordem.data_hora_finalizacao_tratamento_em_campo, 'YYYY-MM-DD HH:mm:ss');
                            } else if (ordem.data_hora_finalizacao_tratamento_remoto) {
                                referenciaAtual = moment(ordem.data_hora_finalizacao_tratamento_remoto, 'YYYY-MM-DD HH:mm:ss');
                            } else if (ordem.data_hora_conclusao) {
                                referenciaAtual = moment(ordem.data_hora_conclusao, 'YYYY-MM-DD HH:mm:ss');
                            }
                        }

                        if (referenciaAtual.isAfter(limite)) {
                            slaLabel = "Violado";
                            slaColor = "#d32f2f";
                        } else {
                            const businessMinutesRestante = calculateBusinessHoursBetween(referenciaAtual, limite, eventosAtivos);
                            const businessHoursRestante = businessMinutesRestante / 60;
                            const prazoOrig = ordem.prazo_maximo_conclusao ? parseInt(ordem.prazo_maximo_conclusao) : 72;
                            if (businessHoursRestante <= (prazoOrig * 0.25)) {
                                slaLabel = "Atenção";
                                slaColor = "#ed6c02";
                            } else {
                                slaLabel = "No Prazo";
                                slaColor = "#2e7d32";
                            }
                        }
                    }

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {/* Linha 1: Criação */}
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: 12, color: themeHelper.text, fontWeight: 'bold' }}>{fDt}</span>
                                {tempoAtras && <span style={{ fontSize: 10, color: themeHelper.textSecondary }}>({tempoAtras})</span>}
                            </Box>
                            
                            {/* Linha 2: SLA / Prioridade */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <span style={{ fontSize: 12 }}>{prioridadeIcon}</span>
                                    <span style={{ fontSize: 10, fontWeight: 'bold', color: prioridadeColor }}>{prioridadeLabel}</span>
                                </Box>
                                <Chip size="small" label={slaLabel} sx={{ backgroundColor: slaColor, color: 'white', fontWeight: 'bold', fontSize: 9, height: 18 }} />
                            </Box>
                        </Box>
                    );
                }
            },
            {
                header: 'Instalação',
                size: 150,
                id: 'instalacao',
                enableSorting: false,
                accessorFn: row => row.instalacao_nome || returnDescricaoInstalacao(row.instalacao),
                Cell: ({ cell }) => (
                    <span style={{ fontSize: 13, color: themeHelper.text }}>
                        {cell.getValue()}
                    </span>
                )
            },
            {
                header: 'Solicitação',
                id: 'nome_solicitacao',
                size: 150,
                enableSorting: false,
                accessorFn: row => row.nome_solicitacao,
                Cell: ({ renderedCellValue }) => (
                    <span style={{ fontSize: 12, color: themeHelper.text }}>
                        {renderedCellValue || ''}
                    </span>
                ),
            },
            {
                header: 'Descrição',
                id: 'descricao_solicitacao',
                size: 200,
                enableSorting: false,
                accessorFn: row => row.descricao_solicitacao,
                Cell: ({ cell }) => <TextoComTooltip text={cell.getValue()} max={40} />,
            },
            {
                header: 'Status / Etapa',
                id: 'status_etapa',
                size: 180,
                enableSorting: false,
                accessorFn: row => row.status_ordem,
                Cell: ({ row }) => {
                    const item = row.original;
                    const status = getStatusInfo(item.status_ordem);

                    const showIndicators = [1, 2, 3].includes(item.status_ordem);

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <Chip
                                label={status.label}
                                size="small"
                                sx={{
                                    backgroundColor: status.color,
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontSize: 10,
                                    height: 20
                                }}
                            />
                            {showIndicators && (
                                <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', mt: 0.5 }}>
                                    <Tooltip title={item.veiculo_placa ? `Veículo: ${item.veiculo_modelo} (${item.veiculo_placa})` : "Veículo não selecionado"}>
                                        <DirectionsCarIcon sx={{ fontSize: 18, color: item.veiculo_placa ? '#2e7d32' : '#d32f2f' }} />
                                    </Tooltip>
                                    <Tooltip title={item.colaboradores_nomes ? `Equipe: ${item.colaboradores_nomes}` : "Equipe não selecionada"}>
                                        <GroupsIcon sx={{ fontSize: 18, color: item.colaboradores_nomes ? '#2e7d32' : '#d32f2f' }} />
                                    </Tooltip>
                                    <Tooltip title={item.total_itens > 0 ? "Itens selecionados" : "Itens não selecionados"}>
                                        <FactCheckIcon sx={{ fontSize: 18, color: item.total_itens > 0 ? '#2e7d32' : '#d32f2f' }} />
                                    </Tooltip>
                                </Box>
                            )}
                        </Box>
                    );
                }
            },
            {
                header: 'Cronograma',
                id: 'cronograma',
                size: 320,
                enableSorting: false,
                accessorFn: row => row.tarefas_concluidas,
                Cell: ({ row }) => {
                    const item = row.original;
                    const total = item.total_tarefas || 0;
                    const concluidas = item.tarefas_concluidas || 0;
                    const percent = total > 0 ? Math.round((concluidas / total) * 100) : 0;

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Tooltip
                                title={
                                    <Box sx={{ p: 1 }}>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block', mb: 1, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                                            Procedimentos do Agendamento:
                                        </Typography>
                                        <Box sx={{ whiteSpace: 'pre-line', fontSize: '10px' }}>
                                            {item.procedimentos_detalhes || "Nenhum procedimento encontrado"}
                                        </Box>
                                    </Box>
                                }
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={(e) => handleOpenCronograma(item, e)}>
                                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                        {loadingCronogramaId === item.id_ordem_servico ? (
                                            <HistoryToggleOffIcon sx={{ color: themeHelper.textSecondary, fontSize: 24, opacity: 0.5 }} />
                                        ) : percent === 100 ? (
                                            <TaskAltIcon sx={{ color: '#2e7d32', fontSize: 24 }} />
                                        ) : percent > 0 ? (
                                            <HistoryToggleOffIcon sx={{ color: '#0288d1', fontSize: 24 }} />
                                        ) : (
                                            <HistoryToggleOffIcon sx={{ color: '#d32f2f', fontSize: 24 }} />
                                        )}
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: percent === 100 ? '#2e7d32' : themeHelper.text, fontSize: 12 }}>
                                            {percent}%
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: themeHelper.textSecondary, fontSize: 9, display: 'block' }}>
                                            {concluidas}/{total} concluídas
                                        </Typography>
                                    </Box>
                                </Box>
                            </Tooltip>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0 }}>
                                {(() => {
                                    const statusVal = parseInt(item.status_ordem);
                                    const dataHoraCriacaoFormatada = moment(item.data_hora_criacao, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM');
                                    const dataHoraFinalizouTratamentoRemoto = moment(item.data_hora_finalizacao_tratamento_remoto, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM');

                                    const stages = [
                                        { id: 0, title: `Criado: ${dataHoraCriacaoFormatada}`, icon: EditIcon },
                                        { id: 1, title: statusVal === 1 ? 'Tratamento Remoto: Em curso' : 'Tratamento Remoto', icon: ComputerOutlinedIcon },
                                        { id: 2, title: statusVal === 2 ? 'Análise Prévia: Em curso' : 'Análise Prévia', icon: SearchOutlinedIcon },
                                        { id: 3, title: statusVal === 3 ? 'Tratamento em Campo: Em curso' : 'Tratamento em Campo', icon: TaskIcon },
                                        { id: 9, title: statusVal === 9 ? `Conclusão: ${dataHoraFinalizouTratamentoRemoto}` : 'Conclusão', icon: TaskAltIcon }
                                    ];

                                    const getStageState = (stageId) => {
                                        if (statusVal === 9) return 'passed';
                                        if (stageId === 9) return 'future';
                                        if (statusVal === stageId) return 'current';
                                        if (statusVal > stageId) return 'passed';
                                        return 'future';
                                    };

                                    return stages.map((stage, idx) => {
                                        const state = getStageState(stage.id);
                                        const isPassed = state === 'passed';
                                        const isCurrent = state === 'current';
                                        const color = isPassed ? '#2e7d32' : isCurrent ? '#e57373' : themeHelper.textSecondary;

                                        return (
                                            <React.Fragment key={stage.id}>
                                                <TimelineNode
                                                    tooltipTitle={stage.title}
                                                    borderColor={color}
                                                    bgColor={isCurrent ? '#fce4ec' : 'transparent'}
                                                    pulse={isCurrent}
                                                    icon={<stage.icon sx={{ color }} />}
                                                    extra={(stage.id === 1 && statusVal === 2) ? <CancelIcon sx={{ color: 'red', fontSize: 14, ml: '2px' }} /> : null}
                                                />
                                                {idx < stages.length - 1 && (
                                                    <Connector active={statusVal > stage.id || statusVal === 9} pulse={isCurrent} />
                                                )}
                                            </React.Fragment>
                                        );
                                    });
                                })()}
                            </Box>
                        </Box>
                    );
                }
            },
            {
                id: 'envolvidos',
                header: 'Envolvidos',
                size: 200,
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => ({
                    solicitante: row.usuario_solicitante?.nome_amigavel || '',
                    criador: row.usuario_criador?.nome_amigavel || '',
                    analista: row.analista?.nome_amigavel || ''
                }),
                Cell: ({ row }) => {
                    const item = row.original;
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <span style={{ fontSize: 11, color: themeHelper.textSecondary }}>
                                Solicitante: {item.usuario_solicitante?.nome_amigavel}
                            </span>
                            <span style={{ fontSize: 11, color: themeHelper.textSecondary }}>
                                Criador: {item.usuario_criador?.nome_amigavel}
                            </span>
                            <span style={{ fontSize: 11, color: themeHelper.textSecondary }}>
                                Analista: {item.analista?.nome_amigavel}
                            </span>
                        </Box>
                    );
                },
            },
            {
                header: 'Detalhes Agendamento',
                id: 'detalhes_agendamento',
                size: 220,
                enableSorting: false,
                accessorFn: row => row.data_agendada,
                Cell: ({ row }) => {
                    const item = row.original;
                    if (!item.data_agendada) return <span style={{ color: themeHelper.textSecondary, fontSize: 12 }}>—</span>;

                    const inicio = moment(item.data_agendada);
                    const fim = item.data_agendada_fim ? moment(item.data_agendada_fim) : null;
                    const agora = moment();
                    const isEmExecucao = fim ? agora.isBetween(inicio, fim) : false;
                    const isNaoIniciado = agora.isBefore(inicio);

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <ScheduleIcon sx={{ fontSize: 14, color: themeHelper.textSecondary }} />
                                <Typography variant="caption" sx={{ fontWeight: 'bold', color: themeHelper.text }}>
                                    {inicio.format('DD/MM HH:mm')} - {fim ? fim.format('DD/MM HH:mm') : '?'}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {isEmExecucao && (
                                    <Chip
                                        icon={<FiberManualRecordIcon sx={{ fontSize: '10px !important', color: '#fff !important' }} />}
                                        label="Em execução"
                                        size="small"
                                        sx={{ backgroundColor: '#2e7d32', color: '#fff', height: 18, fontSize: 9, '& .MuiChip-icon': { ml: 0.5 } }}
                                    />
                                )}
                                {isNaoIniciado && (
                                    <Chip
                                        label="Não iniciado"
                                        size="small"
                                        variant="outlined"
                                        sx={{ color: '#ed6c02', borderColor: '#ed6c02', height: 18, fontSize: 9 }}
                                    />
                                )}
                            </Box>
                            {item.equipe_nome && (
                                <Typography variant="caption" sx={{ color: themeHelper.textSecondary, fontSize: 10 }}>
                                    {item.equipe_nome} | {item.veiculo_modelo}
                                </Typography>
                            )}
                        </Box>
                    );
                }
            },
            {
                header: 'Extras',
                id: 'descricao_ordem_compra',
                size: 100,
                enableSorting: false,
                accessorFn: row => {
                    // concatena para permitir busca tanto pela descrição quanto pelo ID
                    const descricao = row.descricao_ordem_compra || '';
                    const idCompra = row.id_ordem_compra ? String(row.id_ordem_compra) : '';
                    return `${descricao} ${idCompra}`;
                },
                enableColumnFilter: true,
                filterFn: 'includes',
                Cell: ({ row }) => {
                    const descricao = row.original.descricao_ordem_compra || '';
                    const idCompra = row.original.id_ordem_compra;

                    return (
                        <span style={{ fontSize: 12, color: themeHelper.text, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {descricao}
                            {idCompra > 0 && (
                                <Tooltip title="Abrir Ordem de Compra">
                                    <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={() => window.open(`/gestao/administracao/ordensdecompras/editar/${idCompra}`, '_blank')}
                                    >
                                        <SettingsIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </span>
                    );
                },
            },
        ],
        [darkMode],
    );





    const TextoComTooltip = ({ text, max = 25 }) => {
        if (!text) return "—";

        const curta = text.length > max ? text.substring(0, max) + "..." : text;

        return (
            <Tooltip title={text}>
                <span
                    style={{
                        display: 'inline-block',
                        width: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: 12,
                        color: themeHelper.text,
                        cursor: 'default'
                    }}
                >
                    {curta}
                </span>
            </Tooltip>
        );
    };




    const handleClickAtualizarProcedimento = (id_procedimento_Execucao, id_ordem_servico) => {


        //  window.location.href = "/gestao/administracao/ordensdeservicos/atualizarprocedimentoexecucao/" + id_procedimento_execucao + "/ordemservico/" + id_ordem_servico + "/2/" + 0;


    };


    const getStatusInfo = (status) => {
        switch (status) {
            case 0: return { label: "Aberto", color: "#757575" };
            case 1: return { label: "Em tratamento remoto", color: "#0288d1" };
            case 2: return { label: "Em Analise Previa", color: "#ed6c02" };
            case 3: return { label: "Tratamento em Campo", color: "#2e7d32" };
            case 9: return { label: "Finalizado", color: "#2e7d32" };
            default: return { label: "Desconhecido", color: "#757575" };
        }
    };


    // Formata datas e calcula diferenças
    const formatarTempoDecorrido = (dataInicial) => {
        if (!dataInicial) return "";

        const inicio = new Date(dataInicial);
        const agora = new Date();
        const diffMs = agora - inicio;

        const horas = Math.floor(diffMs / (1000 * 60 * 60));
        const dias = Math.floor(horas / 24);

        if (dias >= 1) return `Criado há ${dias} dia${dias > 1 ? "s" : ""}`;
        if (horas >= 1) return `Criado há ${horas} hora${horas > 1 ? "s" : ""}`;

        return "Criado há menos de 1 hora";
    };

    // Formata intervalo de execução
    const formatarDuracaoExecucao = (inicio, fim) => {
        if (!inicio || !fim) return "";

        const i = new Date(inicio);
        const f = new Date(fim);
        let diff = (f - i) / 1000; // segundos

        const h = Math.floor(diff / 3600);
        diff %= 3600;
        const m = Math.floor(diff / 60);
        const s = Math.floor(diff % 60);

        return `${h}h ${m}m ${s}s`;
    };






    const [motivo, setMotivo] = useState('');

    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
    const [usuarios, setUsuarios] = useState(null);
    const [idOrdemDesignar, setIdOrdemDesiginar] = useState('');



    async function handleDesignar() {


        try {

            console.log("cadastrar chamado");
            const cadastro = {
                motivo: motivo,
                usuario_designador: { id_usuario: Cookies.get("id_usuario") },
                analista: { id_usuario: usuarioSelecionado.id_usuario },
            }

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/ordemservico/designar/' + idOrdemDesignar, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("A Ordem de Serviço foi atualizada!");
                setOpen2(false);
                setUsuarioSelecionado(null);
                setMotivo('');
                setIdOrdemDesiginar('');
                window.location.reload(true);

            }



        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }

    const handleExcluirPermanenteOS = (row) => {
        if (window.confirm("Deseja realmente excluir PERMANENTEMENTE esta Ordem de Serviço? Esta ação não pode ser desfeita.")) {
            try {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };

                api.delete("/v1/protected/ordemservico/excluir/" + row.id_ordem_servico, { headers: headers })
                    .then(() => {
                        alert("Ordem de Serviço excluída com sucesso.");
                        listarOrdensServicos();
                    })
                    .catch((err) => {
                        console.error("Erro ao excluir OS:", err);
                        alert("Erro ao excluir OS: " + (err.response?.data?.message || err.message));
                    });
            } catch (err) {
                console.error("Erro ao excluir OS:", err);
            }
        }
    };

    const handleCancelarOS = (row) => {
        const justificativa = window.prompt("Informe a justificativa para o cancelamento da Ordem de Serviço:");
        if (justificativa !== null && justificativa.trim() !== "") {
            try {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };

                const data = {
                    mensagem_cancelamento: justificativa
                };

                api.put("/v1/protected/ordemservico/cancelar/" + row.id_ordem_servico, data, { headers: headers })
                    .then(() => {
                        alert("Ordem de Serviço cancelada com sucesso.");
                        listarOrdensServicos();
                    })
                    .catch((err) => {
                        console.error("Erro ao cancelar OS:", err);
                        alert("Erro ao cancelar OS: " + (err.response?.data?.message || err.message));
                    });
            } catch (err) {
                console.error("Erro ao cancelar OS:", err);
            }
        } else if (justificativa !== null) {
            alert("A justificativa é obrigatória para o cancelamento.");
        }
    };

    const handleOpen2 = (cellValues) => {

        setIdOrdemDesiginar(cellValues.id_ordem_servico);
        listarUsuarios();
    }




    const handleMenuClick = (newValue) => {
        if (newValue === 0) {
            listarInfoDashboard();
        } else if (newValue === 1) {
            //listarObjetos();
            listarOrdensServicos();
        } else if (newValue === 2) {


        }
        else if (newValue === 11) {


        }
        setValue(newValue);
    };


    async function listarUsuarios() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/user/listartodos", {
                headers: headers
            }).then(function (response) {
                setUsuarios(response.data)
                setOpen2(true);

            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Usuarios: " + _err)

        }

    }

    function returnDescricaoUsuario(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\nNome: " + usuario.nome_amigavel + "\nRegiões de Atuação: " + usuario.regiao_cobertura;

        var dados_colaborador = "";

        if (usuario.tipo_associacao === 0) {
            //colaborador
            dados_colaborador += ("\nDepartamentos: " + usuario.colaborador.departamentos.map(departamento => departamento.nome).join(", "));
            dados_colaborador += ("\nCargos: " + usuario.colaborador.cargos.map(cargo => cargo.nome).join(", "));
            dados_colaborador += ("\nFunções: " + usuario.colaborador.funcoes.map(funcao => funcao.nome).join(", "));


        }

        texto += ("\n" + dados_colaborador);


        return texto;
    }


    const handleClose2 = () => {
        setOpen2(false); // assumindo que você tem um estado chamado 'open' para controlar a abertura do diálogo
    };

    const [rankingSelecao, setRankingSelecao] = useState('MesAtual');


    return (
        <MuiThemeProvider theme={themeV5}>
            <CoreThemeProvider theme={themeV4}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', backgroundColor: themeHelper.bg, color: themeHelper.text }}>



                    <NavegadorGestao
                        Gestao={true}
                        OrdensServicos={true}
                        corFundo={themeHelper.navbarBg} travado={true} corTexto={themeHelper.text}
                    />

                    {/* Botão hamburger mobile chamativo */}
                    {/* Redundant Menu button removed for mobile - using swipe handle instead */}


                    {
                        value === 0 && (
                            <div

                                style={{
                                    paddingTop: 5,
                                    paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                    width: '100%',
                                }}

                            >
                                {!loadingDashboard && (
                                    <Grid item xs={12} container
                                        style={{ width: '100%', margin: 1 }}
                                        direction={'row'} >

                                        <Grid item xs={5} container
                                            style={{ width: '100%', margin: 1 }}
                                            direction={'row'} >

                                            <div style={{ width: '100%', height: '100%' }}>
                                                <ReactApexChart
                                                    options={options}
                                                    series={series}
                                                    type="bar"
                                                />
                                            </div>

                                        </Grid>

                                        <Grid item xs={5} container
                                            style={{ width: '100%', margin: 1 }}
                                            direction={'row'} >

                                            <div style={{ width: '100%', height: '100%' }}>
                                                <ReactApexChart
                                                    options={dadosGrafico.options}
                                                    series={dadosGrafico.series}
                                                    type="bar"
                                                />
                                            </div>

                                        </Grid>



                                        <Grid item xs={6}
                                            style={{
                                                padding: '2px',
                                                backgroundColor: darkMode ? themeHelper.paper : '#191970',
                                                color: themeHelper.text,
                                                borderRadius: '8px',
                                                textAlign: 'center',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                marginTop: '2px',
                                                marginRight: 10,
                                            }}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            {/* Cabeçalho */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontWeight: 'bold',
                                                    padding: '2px',
                                                    borderBottom: `1px solid ${themeHelper.border}`,
                                                }}
                                            >
                                                <span style={{ flex: 1, fontSize: '12px' }}>{"       "}</span>
                                                <span style={{ flex: 1, fontSize: '12px' }}>Problema</span>
                                                <span style={{ flex: 1, fontSize: '12px' }}>Quantidade</span>
                                            </div>

                                            {/* Linhas do Ranking - Renderiza com base na seleção */}
                                            {infoDashboard[`problemasDashboardInfo${rankingSelecao}`]?.map((problema, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '2px',
                                                        backgroundColor: index % 2 === 0
                                                            ? (darkMode ? '#333333' : '#f0f0f0')
                                                            : (darkMode ? '#2a2a2a' : '#ffffff'), // Alterna as cores
                                                        color: themeHelper.text,
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    <span style={{ flex: 1, textAlign: 'center' }}>
                                                        {index === 0 ? '1º' : index === 1 ? '2º' : index === 2 ? '3º' : index + 1 + "º"}
                                                    </span>
                                                    <span style={{ flex: 1, textAlign: 'center' }}>{problema.nome}</span>
                                                    <span style={{ flex: 1, textAlign: 'center' }}>{problema.total}</span>
                                                </div>
                                            ))}


                                            {/* Bolinhas de Seleção */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '10px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <button
                                                    onClick={() => setRankingSelecao('MesAtual')}
                                                    style={{
                                                        backgroundColor: rankingSelecao === 'MesAtual' ? '#ffcc00' : 'transparent',
                                                        border: '2px solid #ffcc00',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        margin: '0 5px',
                                                    }}
                                                />
                                                <span style={{ marginRight: '10px', fontSize: '12px', color: themeHelper.text }}>Mês atual</span>

                                                <button
                                                    onClick={() => setRankingSelecao('TodoPeriodo')}
                                                    style={{
                                                        backgroundColor: rankingSelecao === 'TodoPeriodo' ? '#ffcc00' : 'transparent',
                                                        border: '2px solid #ffcc00',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        margin: '0 5px',
                                                    }}
                                                />
                                                <span style={{ fontSize: '12px', color: themeHelper.text }}>Todo o Periodo</span>
                                            </div>
                                        </Grid>


                                    </Grid>
                                )}
                            </div>)
                    }



                    {
                        value === 1 && (
                            <div
                                style={{
                                    paddingTop: 5,
                                    paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                    width: '100%',
                                }}

                            >

                                {
                                    isCabecalho &&
                                    (
                                        <Grid container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                        >

                                            <Grid container direction="row"
                                                justifyContent="flex-end"
                                                alignItems="center"

                                                item xs={6} sm={6} md={6} lg={6} xl={6}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={regra.includes("ADMIN_OC_MINHAS_OS") ? true : filtroChecked}

                                                            disabled={regra.includes("ADMIN_OC_MINHAS_OS") ? true : false}

                                                            onChange={(e) => handleFiltroChecked(e.target.checked)}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Minhas O.Cs"
                                                />
                                            </Grid>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                                alignItems="center"
                                                item xs={6}
                                            >
                                                <Stack direction="row" spacing={1} sx={{ mr: 2 }}>
                                                    <Tooltip title="Visualização em Lista">
                                                        <IconButton 
                                                            color={viewMode === 'table' ? 'primary' : 'default'} 
                                                            onClick={() => setViewMode('table')}
                                                            sx={{ 
                                                                backgroundColor: viewMode === 'table' ? (darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)') : 'transparent',
                                                                borderRadius: 2
                                                            }}
                                                        >
                                                            <TableRowsIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Visualização em Kanban">
                                                        <IconButton 
                                                            color={viewMode === 'kanban' ? 'primary' : 'default'} 
                                                            onClick={() => setViewMode('kanban')}
                                                            sx={{ 
                                                                backgroundColor: viewMode === 'kanban' ? (darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)') : 'transparent',
                                                                borderRadius: 2
                                                            }}
                                                        >
                                                            <ViewKanbanIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Stack>




                                                <Button style={{ margin: 5 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={novo}
                                                >
                                                    Nova Ordem de Serviço
                                                </Button>

                                                {
                                                    Cookies.get("regra").includes("ROOT_MASTER") && (
                                                        <Button style={{ margin: 1 }}
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={reavaliar}
                                                        >
                                                            Reavaliar Analista
                                                        </Button>
                                                    )
                                                }



                                            </Grid>
                                        </Grid>
                                    )
                                }

                                {loading ?
                                    <Skeleton animation={"wave"} width={'100%'} height={400} style={{ backgroundColor: darkMode ? themeHelper.paper : '#48D1CC' }} />
                                    : (
                                        <Box sx={{
                                            flexGrow: 1,
                                            overflow: 'auto',
                                        }}>
                                            {viewMode === 'table' ? (
                                                <MaterialReactTable
                                                    columns={columns}
                                                    data={objetos}
                                                    enableBottomToolbar
                                                    enableGlobalFilterModes
                                                    manualPagination
                                                    onPaginationChange={setPagination}
                                                    rowCount={totalRegistros}
                                                    state={{ pagination }}
                                                    enableRowActions
                                                    enableStickyHeader
                                                    paginationDisplayMode="pages"
                                                    getRowId={(row) => row.id_ordem_servico}
                                                    enableGrouping
                                                    enableFullScreenToggle
                                                    enableColumnResizing
                                                    layoutMode="grid"
                                                    renderDetailPanel={({ row }) => (
                                                        <OSDetailPanel 
                                                            row={row} 
                                                            darkMode={darkMode} 
                                                            themeHelper={themeHelper} 
                                                            commentsMap={commentsMap}
                                                            isPostingComment={isPostingComment}
                                                            fetchComments={fetchComments}
                                                            handlePostComment={handlePostComment}
                                                            handleUpdatePriority={handleUpdatePriority}
                                                            handleOpenCronograma={handleOpenCronograma}
                                                        />
                                                    )}
                                                    initialState={{
                                                        showGlobalFilter: true,
                                                        showColumnFilters: true,
                                                        columnVisibility: isMobile
                                                            ? {
                                                                id_ordem: true,
                                                                nome_solicitacao: true,
                                                                descricao_solicitacao: true,
                                                                descricao_ordem_compra: false,
                                                                timeline: false,
                                                                instalacao: false,
                                                                envolvidos: false,
                                                                sla_prioridade: false
                                                            }
                                                            : {
        
                                                            },
                                                    }}
                                                    muiTablePaperProps={{
                                                        sx: {
                                                            backgroundColor: themeHelper.paper,
                                                            color: themeHelper.text,
                                                            backgroundImage: 'none',
                                                        },
                                                    }}
                                                    muiTableContainerProps={{
                                                        sx: {
                                                            maxHeight: 'calc(100vh - 250px)', // ajuste 200px conforme altura do topo/botões
                                                            backgroundColor: themeHelper.paper,
                                                        },
                                                    }}
                                                    muiFilterTextFieldProps={{
                                                        sx: {
                                                            '& .MuiInputLabel-root': {
                                                                color: darkMode ? '#aaa' : 'text.secondary',
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                color: themeHelper.text,
                                                            },
                                                        },
                                                    }}
                                                    muiTopToolbarProps={{
                                                        sx: {
                                                            backgroundColor: themeHelper.paper,
                                                            color: themeHelper.text,
                                                        },
                                                    }}
                                                    muiBottomToolbarProps={{
                                                        sx: {
                                                            backgroundColor: themeHelper.paper,
                                                            color: themeHelper.text,
                                                        },
                                                    }}
                                                    muiTableHeadProps={{
                                                        sx: {
                                                            backgroundColor: themeHelper.paper,
                                                            color: `${themeHelper.text} !important`,
                                                        },
                                                    }}
                                                    muiTableHeadCellProps={{
                                                        sx: {
                                                            padding: '2px',
                                                            fontSize: '0.75rem',
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap',
                                                            backgroundColor: themeHelper.paper,
                                                            color: `${themeHelper.text} !important`,
                                                            borderBottom: `1px solid ${themeHelper.border}`,
                                                            '& .MuiTableSortLabel-root': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                            '& .MuiTableSortLabel-root:hover': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                            '& .MuiTableSortLabel-root.Mui-active': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                            '& .MuiTableSortLabel-icon': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                            '& .MuiButtonBase-root': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                            '& .MuiIconButton-root': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                color: `${themeHelper.text} !important`,
                                                            },
                                                        },
                                                    }}
                                                    muiTableBodyCellProps={{
                                                        sx: {
                                                            padding: '5px',
                                                            fontSize: '0.75rem',
                                                            lineHeight: 2,
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                            backgroundColor: themeHelper.paper,
                                                            color: themeHelper.text,
                                                            borderBottom: `1px solid ${themeHelper.border}`,
                                                        },
                                                    }}
        
        
                                                    muiPaginationProps={{
                                                        rowsPerPageOptions: [30, 50, 100, 200, 400, 1000],
                                                        variant: 'outlined',
                                                        sx: darkMode ? {
                                                            color: 'white',
                                                            '& .MuiSelect-icon': { color: 'white' },
                                                            '& .MuiTablePagination-select': { color: 'white' },
                                                            '& .MuiTablePagination-selectLabel': { color: 'white' },
                                                            '& .MuiTablePagination-displayedRows': { color: 'white' },
                                                            '& .MuiPaginationItem-root': { color: 'white' },
                                                            '& .MuiIconButton-root': { color: 'white' }
                                                        } : {}
                                                    }}
                                                    displayColumnDefOptions={{
                                                        'mrt-row-actions': {
                                                            header: 'Ações',
                                                            size: 100,
                                                        },
                                                    }}
                                                    positionActionsColumn="first"
                                                    renderRowActions={({ row }) => (
                                                        <Box sx={{ display: 'flex', gap: '0.2rem', flexDirection: 'row', alignItems: 'center' }}>
                                                            {/* Gerenciar: Apenas se já estiver designada e não finalizada */}
                                                            {parseInt(row.original.status_ordem) > 0 && parseInt(row.original.status_ordem) !== 9 && (
                                                                <Tooltip title="Gerenciar">
                                                                    <IconButton size="small" onClick={() => handleClickEdicao(row.original)}>
                                                                        <EditIcon style={{ color: 'green', fontSize: '1.2rem' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            {/* Designar: Apenas se estiver aberta (0) */}
                                                            {parseInt(row.original.status_ordem) === 0 && (
                                                                <Tooltip title="Designar Analista">
                                                                    <IconButton size="small" color="primary" onClick={() => handleOpen2(row.original)}>
                                                                        <SettingsIcon style={{ fontSize: '1.2rem' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            {/* Cancelar: Se não estiver finalizada (9) */}
                                                            {parseInt(row.original.status_ordem) !== 9 && parseInt(row.original.status_ordem) !== -1 && (
                                                                <Tooltip title="Cancelar">
                                                                    <IconButton size="small" onClick={() => handleCancelarOS(row.original)}>
                                                                        <CancelIcon style={{ color: 'orange', fontSize: '1.2rem' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            {/* Excluir Permanente: Apenas para ROOT_MASTER ou ADMIN */}
                                                            <Tooltip title="Excluir Permanente (Apenas Root)">
                                                                <IconButton 
                                                                    size="small" 
                                                                    onClick={() => handleExcluirPermanenteOS(row.original)}
                                                                    disabled={!(Cookies.get("regra")?.includes("ROOT_MASTER") || Cookies.get("regra")?.includes("ADMIN"))}
                                                                >
                                                                    <DeleteIcon style={{ 
                                                                        color: (Cookies.get("regra")?.includes("ROOT_MASTER") || Cookies.get("regra")?.includes("ADMIN")) ? 'red' : 'gray', 
                                                                        fontSize: '1.2rem',
                                                                        opacity: (Cookies.get("regra")?.includes("ROOT_MASTER") || Cookies.get("regra")?.includes("ADMIN")) ? 1 : 0.3
                                                                    }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    )}
        
                                                />
                                            ) : (
                                                <KanbanView 
                                                    data={objetos} 
                                                    darkMode={darkMode} 
                                                    themeHelper={themeHelper} 
                                                    handleClickEdicao={handleClickEdicao}
                                                    getStatusInfo={getStatusInfo}
                                                    handleUpdatePriority={handleUpdatePriority}
                                                />
                                            )}
                                        </Box>
                                    )
                                }
                            </div>
                        )
                    }


                    {
                        value === 11 && (
                            <div
                                style={{
                                    paddingTop: 5,
                                    paddingLeft: isMobile ? 0 : !isMobile && open ? 230 : 50,
                                    paddingRight: isMobile ? 0 : 0,
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    overflowX: 'hidden'
                                }}
                            >
                                <Tarefas darkMode={darkMode} themeHelper={themeHelper} handleClickEdicao={handleClickEdicao} />
                            </div>
                        )
                    }



                    {value === 2 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >


                            <div>Relatorios</div>

                        </div>
                    )}





                    <Dialog
                        open={open2}
                        onClose={handleClose2}
                        PaperProps={{
                            sx: {
                                maxWidth: 600,
                                minWidth: 300,
                                backgroundColor: themeHelper.paper,
                                color: themeHelper.text,
                            },
                        }}
                    >
                        <DialogTitle>Designar Analista</DialogTitle>
                        <DialogContent>
                            <Grid
                                direction={"row"}
                                item xs={12}
                                container
                                alignItems={'center'}
                                justifyContent={'center'}
                                spacing={3}
                            >

                                <Grid
                                    item xs={12}
                                    style={{ margin: 20, padding: 20 }}
                                >
                                    <TextField
                                        label="Motivo"
                                        variant="outlined"
                                        fullWidth
                                        value={motivo}
                                        onChange={(e) => setMotivo(e.target.value)}
                                    />
                                </Grid>
                                <Grid
                                    item xs={12}
                                >
                                    <Autocomplete
                                        id="select-analista"
                                        options={usuarios}
                                        getOptionLabel={(usuario) => returnDescricaoUsuario(usuario).replace(/<br \/>/g, '\n')}
                                        value={usuarioSelecionado}
                                        onChange={(e, v) => setUsuarioSelecionado(v)}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((cotacao) => {
                                                const cotacaoText = returnDescricaoUsuario(cotacao).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Usuário " multiline rows={3} />
                                        )}

                                        renderOption={(option) => (
                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoUsuario(option).replace(/\n/g, '<br>') }} />
                                        )}
                                    />

                                    <Button style={{ margin: 20, padding: 20 }} variant="contained" color="primary" onClick={handleDesignar}>
                                        Designar
                                    </Button>
                                </Grid>



                            </Grid>

                        </DialogContent>
                    </Dialog>


                    {isMobile && !open && (
                        <div
                            onClick={() => setOpen(true)}
                            onTouchStart={(e) => {
                                touchStartRef.current = e.touches[0].clientX;
                            }}
                            onTouchMove={(e) => {
                                e.preventDefault();
                                if (touchStartRef.current === null) return;
                                const touchCurrentX = e.touches[0].clientX;
                                if (touchCurrentX - touchStartRef.current > 10) { // Threshold de 10px para considerar swipe
                                    setOpen(true);
                                    touchStartRef.current = null; // Reset para evitar múltiplos triggers
                                }
                            }}
                            onTouchEnd={() => {
                                touchStartRef.current = null;
                            }}
                            style={{
                                position: 'fixed',
                                left: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '20px', // Aumentado para facilitar o toque/drag
                                height: '60px',
                                backgroundColor: darkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)',
                                borderRadius: '0 8px 8px 0',
                                zIndex: 1300,
                                cursor: 'pointer',
                                backdropFilter: 'blur(2px)',
                                boxShadow: '1px 0 4px rgba(0,0,0,0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                touchAction: 'none' // Importante para o navegador não tentar scrollar
                            }}
                        >
                            <div style={{ width: '4px', height: '25px', backgroundColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)', borderRadius: '2px' }} />
                        </div>
                    )}

                    {isMobile ? (
                        <SwipeableDrawer
                            open={open}
                            onClose={() => setOpen(false)}
                            onOpen={() => setOpen(true)}
                            swipeAreaWidth={80}
                            disableDiscovery={false}
                            disableBackdropTransition={false}
                            SwipeAreaProps={{
                                onClick: () => setOpen(true), // Catch click that passed through handle
                                style: { zIndex: 1200 } // Ensure SwipeArea is above content to catch swipes
                            }}
                            anchor="left"
                            sx={{
                                '& .MuiDrawer-paper': {
                                    width: 230,
                                    bgcolor: themeHelper.navbarBg,
                                    color: themeHelper.text,
                                    zIndex: 1300,
                                },
                            }}
                        >
                            <List>
                                <ListItem
                                    sx={{
                                        backgroundColor: value === 3 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => { handleMenuClick(3); setOpen(false); }}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><InsightsIcon /></ListItemIcon>
                                    <ListItemText primary="Visão Estratégica" sx={{ color: themeHelper.text }} />
                                </ListItem>
                                <ListItem
                                    sx={{
                                        backgroundColor: value === 0 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => { handleMenuClick(0); setOpen(false); }}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary="Dashboard" sx={{ color: themeHelper.text }} />
                                </ListItem>
                                <ListItem
                                    sx={{
                                        backgroundColor: value === 1 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => { handleMenuClick(1); setOpen(false); }}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><PostAddIcon /></ListItemIcon>
                                    <ListItemText primary="Ordens de Serviços" sx={{ color: themeHelper.text }} />
                                </ListItem>

                                <ListItem
                                    sx={{
                                        backgroundColor: value === 11 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => { handleMenuClick(11); setOpen(false); }}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><TaskIcon /></ListItemIcon>
                                    <ListItemText primary="Tarefas" sx={{ color: themeHelper.text }} />
                                </ListItem>

                                <ListItem
                                    sx={{
                                        backgroundColor: value === 2 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => { handleMenuClick(2); setOpen(false); }}
                                >
                                    <ListItemIcon sx={{ color: themeHelper.text }}><PostAddIcon /></ListItemIcon>
                                    <ListItemText primary="Relatoria" sx={{ color: themeHelper.text }} />
                                </ListItem>
                            </List>
                        </SwipeableDrawer>
                    ) : (
                        <Drawer
                            variant="permanent"
                            open={open}
                            onClose={toggleDrawer}
                            anchor="left"
                            sx={{
                                '& .MuiDrawer-paper': {
                                    top: '80px',
                                    height: 'calc(100vh - 100px)',
                                    width: open ? 230 : 50,
                                    transition: 'width 0.3s',
                                    overflowX: 'hidden',
                                    bgcolor: themeHelper.navbarBg,
                                    borderRight: `1px solid ${themeHelper.border}`,
                                },
                            }}
                        >



                            <IconButton onClick={toggleDrawer} sx={{ alignSelf: 'flex-end', m: 1 }}>
                                {open ? <ChevronLeftIcon sx={{ color: themeHelper.text }} /> : <ChevronRightIcon sx={{ color: themeHelper.text }} />}
                            </IconButton>

                            <List>
                                <ListItem
                                    sx={{
                                        backgroundColor: value === 3 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => handleMenuClick(3)}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><InsightsIcon /></ListItemIcon>
                                    <ListItemText primary="Visão Estratégica" sx={{ color: themeHelper.text }} />
                                </ListItem>
                                <ListItem
                                    sx={{
                                        backgroundColor: value === 0 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => handleMenuClick(0)}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary="Dashboard" sx={{ color: themeHelper.text }} />
                                </ListItem>
                                <ListItem
                                    sx={{
                                        backgroundColor: value === 1 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => handleMenuClick(1)}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><PostAddIcon /></ListItemIcon>
                                    <ListItemText primary="Ordens de Serviços" sx={{ color: themeHelper.text }} />
                                </ListItem>

                                <ListItem
                                    sx={{
                                        backgroundColor: value === 11 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => handleMenuClick(11)}>
                                    <ListItemIcon sx={{ color: themeHelper.text }}><TaskIcon /></ListItemIcon>
                                    <ListItemText primary="Tarefas" sx={{ color: themeHelper.text }} />
                                </ListItem>

                                <ListItem
                                    sx={{
                                        backgroundColor: value === 2 ? (darkMode ? '#b36b00' : 'orange') : 'transparent',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#444' : '#f5f5f5'
                                        }
                                    }}
                                    button onClick={() => handleMenuClick(2)}
                                >
                                    <ListItemIcon sx={{ color: themeHelper.text }}><PostAddIcon /></ListItemIcon>
                                    <ListItemText primary="Relatoria" sx={{ color: themeHelper.text }} />
                                </ListItem>
                            </List>
                        </Drawer>
                    )}

                    {value === 3 && (
                        <div style={{ flex: 1, paddingLeft: isMobile ? 0 : !isMobile && open ? 230 : 50, transition: 'padding-left 0.3s' }}>
                            <VisaoGeral />
                        </div>
                    )}

                </div >

                <Dialog
                    open={openCronograma}
                    onClose={handleCloseCronograma}
                    maxWidth="xl"
                    fullWidth
                >
                    <DialogContent style={{ padding: 0 }}>
                        {ordemServicoCronograma && (
                            <Cronograma
                                ordemServicoRecebida={ordemServicoCronograma}
                                listarInformacoes={listarInformacoesCronograma}
                            />
                        )}
                    </DialogContent>
                </Dialog>

            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}

const KanbanView = ({ data, darkMode, themeHelper, handleClickEdicao, getStatusInfo, handleUpdatePriority, handleOpenCronograma }) => {
    const statuses = [
        { code: '0', title: 'Abertas', color: '#808080' },
        { code: '2', title: 'Em Análise Previa', color: '#ff9800' },
        { code: '1', title: 'Tratamento Remoto', color: '#2196f3' },
        { code: '3', title: 'Tratamento em Campo', color: '#4caf50' },
        { code: '9', title: 'Finalizadas', color: '#2e7d32' }
    ];

    const grouped = statuses.map(status => ({
        ...status,
        items: data.filter(item => String(item.status_ordem) === status.code)
    }));

    const calculateOpenTime = (creationDate) => {
        if (!creationDate) return '—';
        const start = moment(creationDate);
        const end = moment();
        const duration = moment.duration(end.diff(start));
        
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        
        if (days > 0) return `${days}d ${hours}h`;
        if (hours > 0) return `${hours}h ${duration.minutes()}m`;
        return `${duration.minutes()}m`;
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                gap: 2, 
                p: 2, 
                height: 'calc(100vh - 250px)', 
                overflowX: 'auto',
                '&::-webkit-scrollbar': { height: 8 },
                '&::-webkit-scrollbar-thumb': { backgroundColor: darkMode ? '#555' : '#ccc', borderRadius: 4 }
            }}
        >
            {grouped.map((col) => (
                <Box 
                    key={col.code} 
                    sx={{ 
                        minWidth: 320, 
                        maxWidth: 320, 
                        display: 'flex', 
                        flexDirection: 'column',
                        bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                        borderRadius: 2,
                        border: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'}`
                    }}
                >
                    <Box sx={{ p: 2, borderBottom: `3px solid ${col.color}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: themeHelper.text }}>
                            {col.title}
                        </Typography>
                        <Chip label={col.items.length} size="small" sx={{ bgcolor: col.color, color: '#fff', fontWeight: 'bold' }} />
                    </Box>

                    <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        {col.items.map((item) => {
                            const openTime = calculateOpenTime(item.data_hora_criacao);
                            const total = item.total_tarefas || 0;
                            const concluidas = item.tarefas_concluidas || 0;
                            const percent = total > 0 ? Math.round((concluidas / total) * 100) : 0;

                            const priorities = [
                                { label: 'Comum', color: '#808080' },
                                { label: 'Urgente', color: '#ed6c02' },
                                { label: 'Priorizar', color: '#d32f2f' }
                            ];
                            const prio = priorities[item.nivel_prioridade] || priorities[0];

                            return (
                                <Tooltip
                                    key={item.id_ordem_servico}
                                    enterDelay={1000}
                                    enterNextDelay={1000}
                                    placement="right"
                                    interactive
                                    title={
                                        <Box sx={{ 
                                            p: 0, 
                                            minWidth: 600, 
                                            maxWidth: 800, 
                                            maxHeight: '90vh', 
                                            overflowY: 'auto',
                                            '&::-webkit-scrollbar': { width: 6 },
                                            '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: 3 }
                                        }}>
                                            <OSDetailPanel 
                                                row={{ original: item }} 
                                                darkMode={darkMode} 
                                                themeHelper={themeHelper} 
                                                handleUpdatePriority={handleUpdatePriority}
                                                handleOpenCronograma={handleOpenCronograma}
                                            />
                                        </Box>
                                    }
                                >
                                    <Card 
                                        onClick={() => handleClickEdicao(item)}
                                        sx={{ 
                                            cursor: 'pointer',
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                            bgcolor: themeHelper.paper,
                                            border: `1px solid ${themeHelper.border}`,
                                            minHeight: 180,
                                            flexShrink: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: 3
                                            }
                                        }}
                                    >
                                        <CardContent sx={{ p: '12px !important', flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <Typography variant="caption" sx={{ fontWeight: 'bold', color: col.color }}>
                                                    #{item.id_ordem_servico}
                                                </Typography>
                                                <Chip 
                                                    label={prio.label} 
                                                    size="small" 
                                                    sx={{ 
                                                        height: 16, 
                                                        fontSize: '0.6rem', 
                                                        bgcolor: prio.color, 
                                                        color: '#fff',
                                                        fontWeight: 'bold'
                                                    }} 
                                                />
                                            </Box>
                                            
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: themeHelper.text, fontSize: '0.85rem', lineBreak: 'anywhere' }}>
                                                {item.nome_solicitacao}
                                            </Typography>

                                            <Box>
                                                <Typography variant="caption" display="block" sx={{ color: darkMode ? '#aaa' : '#666', fontSize: '0.7rem' }}>
                                                    <b>Local:</b> {item.instalacao_nome}
                                                </Typography>
                                                <Typography variant="caption" display="block" sx={{ color: darkMode ? '#aaa' : '#666', fontSize: '0.7rem' }}>
                                                    <b>Criado por:</b> {item.usuario_criador?.nome_amigavel || '—'}
                                                </Typography>
                                                <Typography variant="caption" display="block" sx={{ color: darkMode ? '#aaa' : '#666', fontSize: '0.7rem' }}>
                                                    <b>Abertura:</b> {moment(item.data_hora_criacao).format('DD/MM HH:mm')} ({openTime})
                                                </Typography>
                                            </Box>

                                            <Box sx={{ mt: 'auto', pt: 1 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                    <Typography variant="caption" sx={{ fontSize: '0.65rem', color: themeHelper.textSecondary }}>
                                                        Progresso: {concluidas}/{total}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 'bold', color: themeHelper.text }}>
                                                        {percent}%
                                                    </Typography>
                                                </Box>
                                                <LinearProgress 
                                                    variant="determinate" 
                                                    value={percent} 
                                                    sx={{ 
                                                        height: 4, 
                                                        borderRadius: 2, 
                                                        bgcolor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                                        '& .MuiLinearProgress-bar': {
                                                            bgcolor: percent === 100 ? '#4caf50' : '#2196f3'
                                                        }
                                                    }} 
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Tooltip>
                            );
                        })}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};



